import type { ComponentProps } from 'react';
import { Input } from './Input';

export const FileInput = (props: Omit<ComponentProps<typeof Input>, 'inputType'>) => (
  <Input {...props} inputType="file" />
);
